var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Wrapper',{attrs:{"showBack":false},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('van-loading',{staticClass:"fixed",attrs:{"size":"50"}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }